import {translations} from "./translations";
import {FormField} from "../types/enums";

export const formatToCzechDate = (dateString: string | null) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}. ${month}. ${year}`;
}

export const formatCzechDates = (input: string) => {
    if (!input) return "";
    const dates = input.split(', ');

    return dates
        .map(dateStr => {
            const [year, month, day] = dateStr.trim().split('/');
            return `${parseInt(day)}. ${parseInt(month)}. ${year}`;
        })
        .join(', ');
}


export const translate = (text: FormField | string) => {
    return translations[text] ?? text;
}